import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f659269&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f659269')) {
      api.createRecord('7f659269', component.options)
    } else {
      api.reload('7f659269', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f659269&", function () {
      api.rerender('7f659269', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/skeleton/src/index.vue"
export default component.exports